import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import dayjs from 'dayjs';

export function useFoEventBasicInformation(eventDetail) {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!eventDetail) return [];

    const formatDate = (date) => {
      return date ? dayjs(date).format('D.M.YYYY') : '-';
    };

    return [
      {
        label: t('Názov akcie'),
        value: eventDetail.name,
      },
      {
        label: t('Dátum od'),
        value: formatDate(eventDetail.date_from),
      },
      {
        label: t('Dátum do'),
        value: formatDate(eventDetail.date_to),
      },
      {
        label: t('Popis'),
        value: eventDetail.description,
        isRaw: true,
      },
    ];
  }, [eventDetail, t]);
}
